export class CallTypeKeywordContainer extends HTMLElement {
  constructor(call_type) {
    super();
    this.call_type = call_type;
  }

  connectedCallback(){
    this.innerHTML=`
      <div class="call_type_container">
        <input type="hidden" class="call_type_id" value=${this.call_type.call_type_id}>
        <h3>Call Type: ${this.call_type.call_type_text}</h3>
      </div>
    `

    // Lookup call type keywords
    let keyword_triggers = new KeywordTriggers(this.call_type.keywords);
    this.querySelector('.call_type_container').appendChild(keyword_triggers);
  }

  validate(){
    const valid = this.querySelector('keyword-triggers').validate();
    return valid;
  }

  getData(){
    const keywords = this.querySelector('keyword-triggers').getData();
    // console.log('data for call type container this.call_type: ' + JSON.stringify(this.call_type))
    const data = {domain_id: Number(this.call_type.domain_id), call_type_id: Number(this.call_type.call_type_id), keyword_data_attributes: keywords, percentage_match: 10, processing_queue_type_id: this.call_type.processing_queue_type_id}

    if (this.call_type.call_type_keyword_id > 0) {
      data.id = Number(this.call_type.call_type_keyword_id);
    }
    // console.log('data for call type container: ' + JSON.stringify(data))
    return data;
  }
}
customElements.define('call-type-keyword-container', CallTypeKeywordContainer)

// Container for all the keyword text fields for a given Call Type
// REname to CallTypeKeywords
class KeywordTriggers extends HTMLElement {
  constructor(call_type_keywords) {
    super();
    this.call_type_keywords = call_type_keywords;
  }
  connectedCallback() {
    this.innerHTML = 
      ` <div>
          <div class="row">
            <span class="col-sm-6 no-gutters">List of keywords for this call type...</span>
            <div class="col-sm-6">
              <button class="btn btn-outline-primary pull-left" id="add-keyword-btn">Add Keyword</button>
            </div>
          </div>          
        </div>
        <div class="keywords_container"></div>`;

    if(this.call_type_keywords && this.call_type_keywords.length > 0) {
      this.querySelector('#add-keyword-btn').classList.add('hidden');
      this.call_type_keywords.forEach((keyword) => {
        let keywordTextField = new KeywordTextField(keyword);
        this.querySelector('.keywords_container').appendChild(keywordTextField);
      })
    }

    // Used to create the initial text field when the Add Keywrd button is clicked.
    this.querySelector('#add-keyword-btn').addEventListener('click', function(e) {
      e.preventDefault()
      this.querySelector('#add-keyword-btn').classList.add('hidden');
      let keywordTextField = new KeywordTextField();
      this.querySelector('.keywords_container').appendChild(keywordTextField);
    }.bind(this))
  }

  getData(){
    let keywordData = [];
    if (this.validate()) {
      this.querySelectorAll('keyword-text-field:not(.error)').forEach(elem => {
        const v = elem.getData();
        // We validate an empty value as valid, thinking folks may create multiple
        // text fields to enter a lot of keywords but no populate them all.
        // We ignore those here.
        if (v.keyword.trim().length > 0){
          keywordData.push(v);
        }
      })
    }

    return keywordData;
  }
  
  validate() {
    let isValid = true;

    // Validates keyword data. Marking keywords as errors.
    this.querySelectorAll('keyword-text-field').forEach(elem => {
      if (! elem.validate()){
        isValid = false;
      }
    });

    return isValid
  }
}

customElements.define('keyword-triggers', KeywordTriggers)

class KeywordTextField extends HTMLElement {
  constructor(keyword = null) {
    super();
    this.keyword = keyword;
  }
  connectedCallback() {
    this.keywords_container = this.closest(".keywords_container");
    this.innerHTML = 
    `<style>
      .keyword-row {
        margin-bottom: 20px;
        position: relative;
      }
    </style>
    <div class="row keyword-row">
      <div class="errors"></div>
      <div class="col-md-5">
        <input type="text" 
        tabindex="0"
        ${this.keyword ? `data-keyword_phrase_id=${this.keyword.id}` : ""}
        class="form-control keyword-phrase" 
        placeholder="Enter a keyword or phrase" 
        value="${this.keyword != null ? this.keyword.keyword : ""}">
      </div>
      <div class="col-md-2 keyword-add" style="line-height:30px;">
        <a class="remove_row"><span class="fa fa-minus"></span></a>
        <a class="add_row"><span class="fa fa-plus"></span></a>
      </div>
    </div>`;

    this.querySelector('.add_row').addEventListener('click', this.addRow.bind(this))
    this.querySelector('.remove_row').addEventListener('click', this.removeRow.bind(this))
  }
  
  addRow() {
    const keywordTextField = new KeywordTextField();
    this.keywords_container.appendChild(keywordTextField);
    keywordTextField.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest" });
    keywordTextField.querySelector('input').focus();
  }

  removeRow() {
    this.keywords_container.removeChild(this)
    if(this.keywords_container.childNodes.length == 0) {
      const btn = this.keywords_container.parentNode.querySelector('#add-keyword-btn')
      if (btn){
        btn.classList.remove('hidden');
      }
    }
  }

  // keyphrase must be greater than 4 characters
  validate() {
    let errors = "";
    const keywordPhraseEl = this.querySelector(".keyword-phrase");
    const val = keywordPhraseEl.value.trim();
    const isValid = ((val.length === 0) || (val.length > 0 && val.length >= 4));
    if (! isValid){
      keywordPhraseEl.classList.add('error');
      errors += `<div class="alert alert-danger alert-dismissible" role="alert" style="margin-top:4px">
      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      <strong>Warning!</strong> Please provide a keyword or keyword phrase (min 4 characters).
      </div>`;
    }
    
    this.querySelector('.errors').innerHTML = errors;

    return isValid;
  }
  
  getData() {
    const el = this.querySelector(".keyword-phrase");
    const value = el.value.trim();
    const id = el.getAttribute('data-keyword_phrase_id');
    if (id !== null) {
      return {id: Number(id), keyword: value} // for editing keywords
    }
    else {
      return {keyword: value} // for new keywords
    }
  }
}

customElements.define('keyword-text-field', KeywordTextField)